/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */

export type ConversationMessageStatus =
  (typeof ConversationMessageStatus)[keyof typeof ConversationMessageStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationMessageStatus = {
  pending: "pending",
  sent: "sent",
  failed: "failed",
  received: "received",
} as const;
